export const pageList = [
  {
    index: 0,
    name: 'how',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/how-does-it-work-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/how-does-it-work-body-bg-min.jpg',
  },
  {
    index: 1,
    name: 'how_1',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/how-does-it-work-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/how-does-it-work-body-bg-min.jpg',
  },
  {
    index: 2,
    name: 'how_2',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/how-does-it-work-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/how-does-it-work-body-bg-min.jpg',
  },
  {
    index: 3,
    name: 'how_3',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/how-does-it-work-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/how-does-it-work-body-bg-min.jpg',
  },
  {
    index: 4,
    name: 'tools',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/tools-and-prindiples-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/tools-and-prindiples-body-bg-min.jpg',
  },
  {
    index: 5,
    name: 'tools_1',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/tools-and-prindiples-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/tools-and-prindiples-body-bg-min.jpg',
  },
  {
    index: 6,
    name: 'tools_2',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/tools-and-prindiples-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/tools-and-prindiples-body-bg-min.jpg',
  },
  {
    index: 7,
    name: 'tools_3',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/tools-and-prindiples-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/tools-and-prindiples-body-bg-min.jpg',
  },
  {
    index: 8,
    name: 'tools_4',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/tools-and-prindiples-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/tools-and-prindiples-body-bg-min.jpg',
  },
  {
    index: 9,
    name: 'tools_5',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/tools-and-prindiples-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/tools-and-prindiples-body-bg-min.jpg',
  },
  {
    index: 10,
    name: 'secure',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/secure-data-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/secure-data-body-bg-min.jpg',
  },
  {
    index: 11,
    name: 'secure_1',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/secure-data-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/secure-data-body-bg-min.jpg',
  },
  {
    index: 12,
    name: 'secure_2',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/secure-data-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/secure-data-body-bg-min.jpg',
  },
  {
    index: 13,
    name: 'secure_3',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/secure-data-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/secure-data-body-bg-min.jpg',
  },
  {
    index: 14,
    name: 'secure_4',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/secure-data-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/secure-data-body-bg-min.jpg',
  },
  {
    index: 15,
    name: 'guide',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/guide-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/guide-body-bg-min.jpg',
  },
  {
    index: 16,
    name: 'guide_1',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/guide-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/guide-body-bg-min.jpg',
  },
  {
    index: 17,
    name: 'guide_2',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/guide-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/guide-body-bg-min.jpg',
  },
  {
    index: 18,
    name: 'guide_3',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/guide-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/guide-body-bg-min.jpg',
  },
  {
    index: 19,
    name: 'guide_4',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/guide-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/guide-body-bg-min.jpg',
  },
];
